import bikeForSaleQueries from "$/lib/queries/bike-for-sale-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/bikes-for-sale/$bikeId/inspection",
)({
  loader: async ({ context: { queryClient }, params: { bikeId } }) => {
    queryClient.prefetchQuery(bikeForSaleQueries.inspectionPrereqs(bikeId))
    return { crumb: "alfred.pages.bikesForSale.crumbs.inspection" }
  },
})
